export const COUNT_OF_SERVICE_TYPE = 5;

export const WORK_REQUEST_TYPE = {
  OPEN: "OPEN",
  COMPLETED: "COMPLETED",
  PLANNED: "PLANNED",
  APPROVAL_REQUIRED: "APPROVAL_REQUIRED",
};
